import React, { FC, ReactNode } from 'react';

import { useTheme } from '../../util/theme';
import HighContrastBorder from '../HighContrastBorder';

import { getClassNames } from './PageLayoutHeader.styles.legacy';

export interface PageLayoutHeaderProps {
  readonly suppressDropShadow?: boolean;
  readonly children: ReactNode;
}

const PageLayoutHeader: FC<PageLayoutHeaderProps> = ({ suppressDropShadow = false, children }) => {
  const theme = useTheme();

  return (
    <header className={getClassNames(suppressDropShadow, theme).header} role="banner">
      <HighContrastBorder bottom={true}>{children}</HighContrastBorder>
    </header>
  );
};

export default PageLayoutHeader;
